import { AnalyticsRequest, GroupBy, Sort } from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';

export const HyperSpaceLineChart: Widget = {
    type: 'hyperSpaceLineChart',
    id: 'hyper-space-line-chart',
    name: 'Line Chart',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        new AnalyticsRequest({
            limit: 2000,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.day },
                    INBOUND_MESSAGE: { source: ListeningDimensions.day, dimensionName: 'snCTm' },
                    PLATFORM: { source: ListeningDimensions.day, dimensionName: 'date' },
                    BENCHMARKING: { source: ListeningDimensions.day, dimensionName: 'date' },
                    PAID: { source: ListeningDimensions.day, dimensionName: 'measurementTime' },
                    ADVOCACY: { source: ListeningDimensions.day, dimensionName: 'date' },
                    RDB_FIREHOSE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'SN_CREATED_TIME',
                    },
                    STORY_MESSAGE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'CREATED_TIME',
                    },
                }),
                new GroupBy({
                    LISTENING: {
                        source: ListeningDimensions.topicName,
                        limitType: 'TOP',
                        limit: 8,
                    },
                    INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 8 },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 8 },
                    BENCHMARKING: { dimensionName: 'BRAND_ID', limitType: 'TOP', limit: 8 },
                    PAID: { dimensionName: 'accountIds', limitType: 'TOP', limit: 8 },
                    ADVOCACY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS', limitType: 'TOP', limit: 8 },
                    STORY_MESSAGE: {
                        dimensionName: 'RDB_DATA_SOURCE',
                        limitType: 'TOP',
                        limit: 8,
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Line Chart',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        baseXYChartOptions: {
            grid: {
                enabled: false,
            },
            xAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
            yAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    //TODO: how should we actually handle this
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
        },
        zeroFill: true,
        legend: {
            enabled: true,
            position: {
                auto: true,
                selectedPosition: 'top',
            },
        },
    },
};
